import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter, Prompt } from 'react-router-dom'
import { FormattedMessage, FormattedHTMLMessage, FormattedDate, injectIntl, intlShape } from 'react-intl'
import { toInteger, without, findIndex, find, map, groupBy, includes, uniq, debounce } from 'lodash'
import moment from 'moment'

import { callApi } from '../services/fetchService'
import { decodePatient } from '../services/encodingService'
import { getItems, getSpecificItems } from '../services/selectService'
import { openPatientRecord, openConsultation } from '../actions'

import FaIcon from '../components/FaIcon'
import AutoSaveButton from '../components/AutoSaveButton'
import { Spin, Tabs, Card, Button, Row, Col, List, message } from 'antd'
const { TabPane } = Tabs



/**
 * Actions form
 */

class ActionsForm extends Component {

    static propTypes = {
        consultation: PropTypes.object.isRequired,
        onActionsChange: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)
        this.state = {
            actions: this.props.consultation.actions
        }
    }

    toggleAction(id) {
        let { actions } = this.state
        const { consultation, onActionsChange } = this.props
        if (includes(actions, id)) {
            actions = without(actions, id)
        } else {
            actions.push(id)
        }
        this.setState({ actions })
        onActionsChange(consultation.id, actions)
    }

    render() {
        const { actions } = this.state

        const allActions = groupBy(getItems('actions', actions), 'category')
        const categories = getSpecificItems('action-categories', uniq(map(getItems('actions', actions), 'category')))

        return (
            <Row gutter={24}>
                {
                    categories.map((item) => (
                        <Col span={8} key={item.id}>
                            <Card title={item.value}>
                                <List itemLayout="horizontal" className="actions-list" dataSource={allActions[item.key]} renderItem={(action) => (
                                    this.props.readonly
                                        ? <List.Item className={"readonly " + (includes(actions, action.id) ? "selected" : null)}>
                                            {action.name}{includes(actions, action.id) ? <FaIcon style={{ float: "right" }} icon="check" color="green" size="2x" /> : null}
                                        </List.Item>
                                        : <List.Item className={includes(actions, action.id) ? "selected" : null} onClick={() => this.toggleAction(action.id)}>
                                            {action.name}{includes(actions, action.id) ? <FaIcon style={{ float: "right" }} icon="check" color="green" size="2x" /> : null}
                                        </List.Item> 
                                )} />
                            </Card>
                        </Col>
                    ))
                }
            </Row>
        )
    }

}



/**
 * Actions view
 */

class PatientActions extends Component {

    static propTypes = {
        openPatientRecord: PropTypes.func.isRequired,
        openConsultation: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        consultation: PropTypes.object,
        intl: intlShape.isRequired,
        session: PropTypes.object.isRequired
    }
    
    state = {
        patientId: null,
        patient: {},
        consultations: null,
        loading: false,
        activeTab: null,
        dirty: {}
    }

    fetch = () => {
        const { intl, openPatientRecord } = this.props
        this.setState({ loading: true })
        callApi([{
            endpoint: 'patients/' + this.state.patientId
        }, {
            endpoint: 'patients/' + this.state.patientId + '/consultations'
        }]).then((data) => {
            decodePatient(data[0]).then((decoded) => {
                data[0] = decoded
                openPatientRecord(data[0])
                this.setState({
                    patient: data[0],
                    consultations: data[1],
                    loading: false
                })
            })
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    componentWillReceiveProps(nextProps) {
        let id = toInteger(nextProps.match.params.id)
        if (this.state.patientId !== id) {
            this.setState({ patientId: id }, () => {
                this.fetch()
            })
        }
    }

    componentWillMount() {
        let id = toInteger(this.props.match.params.id)
        this.setState({ patientId: id })
    }

    componentDidMount() {
        this.fetch()
    }

    saveConsultation = (id) => {
        const { intl } = this.props
        const { consultations, dirty } = this.state
        const consultation = consultations[findIndex(consultations, { id })]
        callApi({
            endpoint: 'consultations/' + consultation.id,
            body: consultation,
            method: 'POST'
        }).catch((err) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
        })
        dirty[id] = false
        this.setState({ dirty })
    }

    addConsultation = () => {
        const { intl, openConsultation } = this.props
        const { consultations } = this.state
        if (this.canAddConsultation()) {
            callApi({
                endpoint: 'consultations',
                body: {
                    patient: this.state.patientId,
                    date: Date.now()
                },
                method: 'PUT'
            }).then((data) => {
                consultations.push(data)
                this.setState({
                    consultations: consultations,
                    activeTab: "" + data.id
                })
                openConsultation(data)
                message.success(this.props.intl.formatMessage({id: "misc.updateSuccess"}))
            }).catch((err) => {
                message.error(intl.formatMessage({id: 'misc.unknownError'}))
            })
            
        }
    }

    canAddConsultation = () => {
        const { consultations } = this.state
        if (consultations.length) {
            const lastDate = consultations[consultations.length-1].date
            return !moment(lastDate).isSame(moment(), 'day')
        }
        return true
    }

    debouncedFunctions = {}
    onActionsChange = (id, actions) => {
        const { consultations, dirty } = this.state
        consultations[findIndex(consultations, { id })].actions = actions
        this.setState({
            consultations: consultations
        })
        if (!this.debouncedFunctions[id]) {
            this.debouncedFunctions[id] = debounce(this.saveConsultation, 3 * 1000, { maxWait: 30 * 1000 })
        }
        this.debouncedFunctions[id](id)
        dirty[id] = true
        this.setState({ dirty })
    }

    forceSave = () => {
        const { dirty } = this.state
        map(dirty, (value, key) => {
            if (value === true) {
                this.saveConsultation(Number(key))
            }
        })
    }

    onTabsChange = (activeTab) => {
        this.setState({ activeTab: "" + activeTab });
    }

    render() {
        const { patient, loading, consultations, activeTab, dirty } = this.state
        const { consultation, intl } = this.props
        const { user } = this.props.session

		if (consultations === null || loading) {
			return (
                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                    <Spin size="large" />
                </div>
            )
        }

        const isDirty = !!find(dirty, value => value === true)

        const currentConsultationId = consultation ? consultation.id : null
        const newActiveTab = activeTab || (consultation ? "" + consultation.id : (consultations.length ? "" + consultations[consultations.length - 1].id : null))
        
        return (
            <div>
                <h1><FaIcon icon="user" fixedWidth /><FormattedHTMLMessage id="patient.actions.title" values={patient} /></h1>
                { this.canAddConsultation() ? <div className="action-bar"><Button onClick={this.addConsultation} disabled={!user.canAddConsultations}><FaIcon icon="plus" /> <FormattedMessage id="patient.misc.addConsultation" /></Button></div> : null }
                {
                    !consultations.length ? (
                        <div className="message" style={{ marginTop: "45px" }}>
                            <FaIcon icon="exclamation-circle" size="8x" />
                            <br /><br />
                            <span style={{ fontSize: "35px" }}><FormattedMessage id="patient.misc.noConsultations" /></span>
                            <br /><br />
                            <FormattedMessage id="patient.misc.noConsultations.description" />
                        </div>
                    ) : (
                        <div>
                            <Tabs onChange={this.onTabsChange} activeKey={newActiveTab}>
                                {
                                    consultations.map((consultation, index) => (
                                        <TabPane tab={consultation.id === currentConsultationId 
                                            ? <strong><FaIcon icon="angle-double-right" size="lg" fixedWidth /> <FormattedDate value={consultation.date} /></strong>
                                            : <FormattedDate value={consultation.date} />
                                        } key={"" + consultation.id}>
                                            <ActionsForm consultation={consultation} onActionsChange={this.onActionsChange} readonly={index !== consultations.length - 1} />
                                        </TabPane>
                                    ))
                                }
                            </Tabs>
                            <AutoSaveButton isDirty={isDirty} onClick={this.forceSave} />
                        </div>
                    )
                }
                <Prompt when={isDirty} message={intl.formatMessage({id: 'misc.unsavedData'})} />
            </div>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    consultation: state.consultation,
    session: state.session
})

export default injectIntl(withRouter(connect(mapStateToProps, {
    openPatientRecord,
    openConsultation
})(PatientActions)))


// WEBPACK FOOTER //
// ./src/views/PatientActions.js